import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { Controller } from 'react-hook-form'
import { industryOptions, currencyOptions, empoyeeCountOptions } from '../../../utils/OptionUtils';
import SelectTag from '../../../components/SelectTag';
import Select from 'react-select'
import { Country, State, City } from 'country-state-city';

const CreateCustomer = ({ show, onClose, handleSubmit, register, errors, onSubmit, control, setValue }) => {
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const fetchCountries = () => {
    const countries = Country.getAllCountries().map((country) => ({
      value: country.isoCode,
      label: country.name,
    }));
    setCountryList(countries);
  };
  const handleCountryChange = (selectedCountry) => {
    if (selectedCountry) {
      setSelectedCountry(selectedCountry);
      const states = State.getStatesOfCountry(selectedCountry.value).map(state => ({
        value: state.isoCode,
        label: state.name
      }));
      setStateList(states);
      setValue("state", null);
    } else {
      setStateList([]);
      setValue("state", null);
    }
  };
  const handleStateChange = (selectedState) => {
    if (selectedState && selectedCountry) {
      const cities = City.getCitiesOfState(selectedCountry.value, selectedState.value).map(city => ({
        value: city.name,
        label: city.name
      }));
      setCityList(cities);
      setValue("city", null);
    } else {
      setCityList([]);
      setValue("city", null);
    }
  };
  useEffect(() => {
    fetchCountries();
  }, []);
  const handleInputChange = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
  }
  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Create Customer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="customer-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Company Name</label>
                <input
                  type="text"
                  {...register('company', {
                    required: 'The company name field is required.',
                    validate: value => typeof value === 'string' || 'Company must be a string'
                  })}
                  className={`form-control ${errors.company ? 'is-invalid' : ''}`}
                />
                {errors.company && <div className="text-danger">{errors.company.message}</div>}
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">GST Number</label>
                <input
                  type="text"
                  {...register('gst_no', {
                    maxLength: {
                      value: 15,
                      message: "The GST number must be 15 characters long."
                    },
                    pattern: {
                      value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/,
                      message: "The GST number format is invalid."
                    }
                  })}
                  className="form-control"
                />
                {errors.gst_no && <div className="text-danger">{errors.gst_no.message}</div>}
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Phone no</label>
                <input
                  type="tel"
                  maxLength={10}
                  {...register('phone', {
                    required: "The phone number field is required.",
                    minLength: {
                      value: 10,
                      message: "The phone number must be 10 digits number"
                    },
                    maxLength: {
                      value: 10,
                      message: "The phone number must be 10 digits number"
                    },
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Phone number must contain only digits"
                    }
                  })}
                  onInput={handleInputChange}
                  className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                />
                {errors.phone && <div className="text-danger">{errors.phone.message}</div>}

              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Website</label>
                <input
                  type="text"
                  {...register('website')}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Industry Type</label>
                <Controller
                  name="industry_type"
                  control={control}
                  rules={{ required: "The industry field is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={industryOptions}
                      placeholder="Select an industry"
                      isSearchable
                      classNamePrefix="react-select"
                      value={industryOptions.find(option => option.value === field.value) || null}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption?.value);
                        setShowOtherInput(selectedOption?.value === 'other');
                      }}
                    />
                  )}
                />
                {errors.industry_type && <span className="text-danger">{errors.industry_type.message}</span>}
              </div>
              {showOtherInput && (
                <div className="form-group">
                  <input
                    type="text"
                    {...register('specify_other')}
                    className="form-control"
                    placeholder="Please specify the industry"
                  />
                </div>
              )}
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Currency</label>
                <Controller
                  name="currency"
                  control={control}
                  rules={{ required: "The currency field is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={currencyOptions}
                      placeholder="Select a currency"
                      isSearchable
                      classNamePrefix="react-select"
                      value={currencyOptions.find(option => option.value === field.value) || null}
                      onChange={(selectedOption) => field.onChange(selectedOption?.value)}
                    />
                  )}
                />
                {errors.currency && <div className="text-danger">{errors.currency.message}</div>}
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Employee Count</label>
                <SelectTag
                  name="employee_count"
                  control={control}
                  label="employee count"
                  isRequired={true}
                  options={empoyeeCountOptions}
                />
                {errors.employee_count && <div className="text-danger">{errors.employee_count.message}</div>}
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  {...register('address')}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Zip Code</label>
                <input
                  type="text"
                  maxLength={6}
                  {...register('zipcode')}
                  onInput={handleInputChange}
                  className={`form-control ${errors.zipcode ? 'is-invalid' : ''}`}
                />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Country</label>
                <SelectTag
                  name="country"
                  control={control}
                  label="country"
                  options={countryList}
                  onChange={(selectedCountry) => {
                    handleCountryChange(selectedCountry);
                    setValue("state", null);
                    setValue("city", null);
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">State</label>
                <SelectTag
                  name="state"
                  control={control}
                  label="state"
                  options={stateList}
                  onChange={(selectedState) => {
                    handleStateChange(selectedState); // Fetch cities based on selected state
                    setValue("city", null);
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">City</label>
                <SelectTag
                  name="city"
                  control={control}
                  label="city"
                  options={cityList}
                />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Qty</label>
                <input
                  type="text"
                  {...register('quantity', {
                    required: "Quantity is required",
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Quantity must contain only digits"
                    }
                  })}
                  className={`form-control ${errors.quantity ? 'is-invalid' : ''}`}
                />
                {errors.quantity && <span className="text-danger">Quantity is required</span>}

              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label className="form-label">Official Email</label>
                <input
                  type="text"
                  {...register('official_email', {
                    required: "Official email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Invalid email format"
                    }
                  })}
                  className={`form-control ${errors.official_email ? 'is-invalid' : ''}`}
                />
                {errors.official_email && <span className="text-danger">Official email is required</span>}

              </div>
            </div>
          </div>
          <div className="text-end">
          <Button variant="danger" size="sm" onClick={onClose} className="me-2">Cancel</Button> 
            <Button variant="primary" size="sm" type="submit">Save</Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default CreateCustomer